import { ChangeDetectorRef, Component, EventEmitter, inject, Injectable, Input, OnDestroy, OnInit, Output, Pipe, PipeTransform } from "@angular/core";
import { debounceTime, distinctUntilChanged, startWith, takeUntil } from "rxjs";


import moment from "moment";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

import { FormControl } from "@angular/forms";
import { filter, tap } from "rxjs/operators";
// @ts-ignore
import * as Diacritics from "diacritics";

import { ExcelService } from '@shared/services/global';
import {
  BUSINESS_EXPORT_DATA_SETTING_CONSTS,
  GOOGLE_SHEET_ACCESS_TOKEN_CONSTS,
  GOOGLE_SHEET_OPEN_MODAL_EXPORT,
  IBusinessExportDataSetting,
  IConfigExportDataGoogleSheet,
  IPageSelectionExportData,
  IParamsLoadSettingExportData,
  IParamsSaveSettingExportDataColumns
} from '@shared/models/business';
import { IDisplayColumn } from '@shared/models/idb';
import { IDataExportSpreadData, INavTabDataGird, ISelectOption } from '@core/models';
import { UserService } from '@core/services/user.service';
import { COMMON_DATE_MOMENT, FILE_NAME_DATE_FORMAT, SCREEN_GRID_MEDIUM } from '@shared/constants';
import { ERROR_CODE } from '@core/constants';
import { FormatPercentPipe } from '@shared/pipes/global';
import { castInt } from '@shared/utils';
import {
  ExcelDataAbstractService,
  IExcelDataAbstractOptions,
  ITabRefExportDataSetting
} from '@shared/components/excel/excel-data-abstract.service';


export type IOptionsExportDataExcelSetting = IExcelDataAbstractOptions & {
  excelService?: ExcelService;
  /**
   * Danh sách "lựa chọn dữ liệu"
   *    + Giá trị truyền vào là text đã translate nếu cần dịch.
   *    + Chỉ hỗ trợ 4 loại "recordAll | recordPage | recordGroupPsParent | recordSelected"
   * */
  excelListPage?: {
    checked: IPageSelectionExportData;
    list: {
      key: IPageSelectionExportData,
      value: string,
    }[];
  };

  /**
   * Một số trang sẽ hỗ trợ logic "Lưu cài đặt này cho lần sau" thì cần truyền type vào
   * Dùng gia trị khai báo trong BUSINESS_EXPORT_DATA_SETTING_CONSTS.TYPE...
   * */
  typeSettingExportData: number;

  /**
   * Cho lựa chọn lặp thông tin sản phẩm không, mặc định không có
   *  + Các trang thuường dùng như: Bán hàng, đơn hàng...
   * */
  rowDataLoopLabel?: string;

  /**
   * Cột thì không bắt buộc tuỳ theo nghiệp vụ từng màn, cơ bản sẽ có 3 dạng
   *    - Không có columns[]: /pos/bill/detail
   *    - Có columns[] nhưng không lưu cài đặt: ...
   *    - Có columns[] có lưu cài đặt: /product/item/index
   * */
  columns?: IDisplayColumn[],
  configFile: {
    fileName: string,
    sheetName: string,
  }
}


const TYPE_USE = {
  NEW: 1,  // File mới hoặc sheetName mới
  AVAILABLE: 2,  // File đã có hoặc sheetName đã có
}
type ISettingState = {
  useSetting?: boolean,
  typeScope: number, //  1 CN; 2 DN
  settingId?: number,
  settingNewName?: string
  settingTypeSave: number //  1 New; 2 Avai
  isSubmit?: boolean,
  settingSaveds?: ISelectOption[],
}

@Component({
  standalone: false,
  selector: 'app-export-data-excel-setting',
  templateUrl: 'export-data-excel-setting.component.html',
  styleUrls: [`export-data-excel-setting.scss`],
})
export class ExportDataExcelSettingModalComponent extends ExcelDataAbstractService implements OnInit, OnDestroy {
  @Input() override options: IOptionsExportDataExcelSetting = {} as IOptionsExportDataExcelSetting
  @Output() output$ = new EventEmitter<IConfigExportDataGoogleSheet>();

  state !: IConfigExportDataGoogleSheet;

  isCheckAll = false;
  /**
   * ---------------------------------------------------------------------------------------------------------------------
   * NEW LOGIC ----------------------------------------------------------------------------------------------
   * ---------------------------------------------------------------------------------------------------------------------
   * */
  // Dữ liệu cần tải từ API --------
  settingArray: Record<'excel' | 'google', IBusinessExportDataSetting[]> = {
    excel: [],
    google: [],
  };
  settingOptions: ISelectOption[] = [];

  // Setting
  settingState: ISettingState = this._createStateSetting();
  settingScopeTypes: ISelectOption[] = [];
  settingSaveTypes: ISelectOption[] = []

  controlKeypress = new FormControl();
  isResultSearch = false;
  private cdr = inject(ChangeDetectorRef);

  constructor(
    public userService: UserService,
    private percent: FormatPercentPipe,
  ) {
    super();
  }

  ngOnInit() {
    this.extendParamsAuth = {
      isOpenExportGG: 1,
    }

    this._initStateConfig();
    this._initStateSTT();

    this.navTabs = [
      {
        ref: 'excel',
        name: 'common.exportExcel',
        icon: 'fal fa-file-excel',
        isActive: !this.state || this.state.tabRef === 'excel'
      },
      {
        ref: 'googleSheets',
        name: '',
        nameOriginal: 'Google Sheets',
        icon: 'fal fa-file-spreadsheet',
        isActive: this.state.tabRef === 'googleSheets'
      }
    ]

    this.preOnLoadHandle((tokenId: number) => {
      this.state.accessTokenId = tokenId;
    });

    this.handleCheckAll();
    this.buildSearch();

    if (this.options.typeSettingExportData) {
      this.loadSettingColumnsExport();
    }

    if (this.options.excelService) {
      this.options.excelService.progressPaginator.pipe(takeUntil(this.appForm.destroyed)).subscribe({
        next: res => {
          if (res == null) {
            // Handler finnal
            return;
          }
          const cal = res.page * res.pageSize;
          this.progressState.totalItems = res.totalItems;
          // Nếu không có totalItems (như ElasticSearch), hiển thị cal thay vì gán về 0
          this.progressState.currentItem = (res.totalItems > 0 && cal > res.totalItems) ? res.totalItems : cal;
          this.progressState.totalPages = res.totalPages;
          this.progressState.currentPage = res.page;
          this.progressState.spreadData = res.resultData as IDataExportSpreadData;

          if (res.isError) {
            this.progressState.isExportSubmit = false;
          }

          if (this.progressState.currentPage > 0 || this.progressState.totalPages > 0) {
            let calculator = 0;
            if (this.progressState.totalPages > 0) {
              calculator = this.percent.transform(
                (this.progressState.currentPage / this.progressState.totalPages) * 100
              ) as number;
            }

            if (this.progressState.totalPages > 0 && calculator >= 100) {
              this.progressState.isFinal = true;
            }
          }

          // Ép Angular cập nhật UI ngay sau khi thay đổi state (tránh lỗi NG0100)
          this.cdr.detectChanges();
        }
      })

      this.options.excelService.subjectEvent$.pipe(takeUntil(this.appForm.destroyed)).subscribe({
        next: res => {
          if (res.type == 'error') {
            this.progressState.isExportSubmit = false;
            this.cdr.detectChanges();
          }
        }
      })
    }
  }

  ngOnDestroy() {
    this.appForm.navService.removeParams([GOOGLE_SHEET_OPEN_MODAL_EXPORT])
    this.appForm.getDestroySubs()
  }

  onChangeValue(key: string, value: any) {
    if (this.errors && this.errors[key] && value) {
      delete this.errors[key];
    }
  }

  /**
   * ---------------------------------------------------------------------------------------------------------------------
   * Funcs init ----------------------------------------------------------------------------------------------
   * ---------------------------------------------------------------------------------------------------------------------
   * */
  private _initStateConfig() {
    const opt$ = this.options;
    const fileName = opt$.configFile.fileName + `_${moment().format(FILE_NAME_DATE_FORMAT)}`;

    const tokenId = castInt(this.appForm.getParam('tokenId'));
    const tabRef = this.appForm.getParam('tabRef');

    this.state = {
      link: this.appForm.navService.currentUri,
      tabRef: tabRef == 'googleSheets' ? 'googleSheets' : 'excel',
      // tabRef: 'googleSheets',
      businessId: this.authService.businessCurrent?.id ?? 0,
      pageSelection: opt$.excelListPage ? opt$.excelListPage.checked : 'recordAll', // Chọn kiểu xuất dữ liệu
      settingId: undefined, // Mẫu cài đặt đã lưu
      accessTokenId: tokenId ? tokenId : undefined, // Tab google sheet mới có đổi tab cần reset
      // Dùng chung cả "Excel | Google Sheet"
      typeUseFile: TYPE_USE.NEW, // 1 Mới | 2 Đã có
      fileNew: {
        fileName: fileName,
        sheetName: '',
      },
      googleFile: {
        typeUseSheet: TYPE_USE.NEW, // Loại sheet đang dùng
        spreadUrl: '',
        spreadSheetNewTitle: '',
        spreadSheetId: 0,
        spreadSheetTitle: '',
      },
      columns: opt$.columns ? opt$.columns.map(col => ({ ...col })) : [],
      rowDataLoop: false
    }

    setTimeout(() => {
      let sheetTranslate = this.appForm.appService.translate(opt$.configFile.sheetName);
      sheetTranslate += ` ${moment().format(COMMON_DATE_MOMENT)}`
      this.state.fileNew.sheetName = sheetTranslate;
      this.state.googleFile.spreadSheetNewTitle = sheetTranslate;
    }, 1000)
  }

  private _initStateSTT() {
    this.settingScopeTypes = [
      {
        value: GOOGLE_SHEET_ACCESS_TOKEN_CONSTS.TYPE_SCOPE_USER,
        label: 'Dùng riêng cho cá nhân',
        iconLeft: {
          classFont: 'fal fa-user',
        }
      },
      {
        value: GOOGLE_SHEET_ACCESS_TOKEN_CONSTS.TYPE_SCOPE_BUSINESS,
        label: 'Dùng chung cho doanh nghiệp',
        iconLeft: {
          classFont: 'fal fa-shop',
        }
      }
    ]
    this.settingSaveTypes = [
      {
        value: TYPE_USE.NEW,
        label: 'Lưu cài đặt mới'
      },
      {
        value: TYPE_USE.AVAILABLE,
        label: 'Ghi đè cài đặt cũ'
      }
    ]
  }

  private _createStateSetting() {
    return {
      typeScope: GOOGLE_SHEET_ACCESS_TOKEN_CONSTS.TYPE_SCOPE_USER, //  1 CN; 2 DN
      settingId: undefined,
      settingNewName: '',
      settingTypeSave: TYPE_USE.NEW //  1 New; 2 Avai
    }
  }

  /**
   * - Chỉ với loại "tự chọn cột" thì columns trả về mới chỉ định thêm display = false
   * - Các loại còn lại columns sẽ được set toàn bộ display = true
   *
   * @Note:
   *    - Đối với
   * */
  onExportData() {
    const stat$ = { ...this.state };
    this.errors = {};
    let isValid = true;
    if (stat$.tabRef == 'excel') {
      if (!stat$.fileNew.fileName) {
        isValid = false;
        this.errors['fileNew.fileName'] = 'Tên bảng tính không được để trống';
      }
      if (!stat$.fileNew.sheetName) {
        isValid = false;
        this.errors['fileNew.sheetName'] = 'Tên trang tính không được để trống';
      }
      if (stat$.fileNew.sheetName.length > 31) {
        isValid = false;
        this.appForm.notifyWarning('common.sheetName.limit');
      }
    } else {
      if (stat$.typeUseFile == TYPE_USE.NEW) {
        if (!stat$.fileNew.fileName) {
          isValid = false;
          this.errors['fileNew.fileName'] = 'Tên bảng tính không được để trống';
        }
        if (!stat$.googleFile.spreadSheetNewTitle) {
          isValid = false;
          this.errors['spreadSheetNewTitle'] = 'Tên trang tính không được để trống';
        }
      } else {
        if (!this.getGoogleSheetsSpreadId(stat$.googleFile.spreadUrl)) {
          isValid = false;
          this.errors['spreadId'] = 'Link file Google Sheets không hợp lệ';
        }
        if (stat$.googleFile.typeUseSheet == TYPE_USE.AVAILABLE && !stat$.googleFile.spreadSheetId) {
          isValid = false;
          this.errors['spreadSheetId'] = 'Bạn chưa chọn sheet có sẵn';
          this.appForm.notifyWarning([this.errors['spreadSheetId']]);
        }
        if (stat$.googleFile.typeUseSheet == TYPE_USE.NEW && !stat$.googleFile.spreadSheetNewTitle) {
          isValid = false;
          this.errors['spreadSheetNewTitle'] = 'Tên trang tính không được để trống';
        }
      }
    }
    if (!isValid) {
      return;
    }
    this.progressState.isExportSubmit = true;
    this.output$.next(stat$);
  }


  /**
   * Handle API -------------------------------------------------------------------------------------------------------
   * */

  // Đổi tab excel
  override onChangeTab(tab: INavTabDataGird) {
    super.onChangeTab(tab, (tokenId: number) => {
      this.state.accessTokenId = tokenId;
    });

    this.state.tabRef = tab.ref as ITabRefExportDataSetting;

    // Reset cài đặt đã lưu
    this.state.settingId = undefined;
    this.settingOptions = [];
    this.loadSettingColumnsExport();
  }

  private loadSettingColumnsExport() {
    if (!this.options.typeSettingExportData) {
      return;
    }

    const params: IParamsLoadSettingExportData = {
      type: this.options.typeSettingExportData,
      format: BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_EXCEL,
    }
    if (this.state.tabRef == 'googleSheets') {
      params.format = BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_GOOGLE_SHEET;
    }

    switch (params.format) {
      case BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_EXCEL:
        if (this.settingArray.excel.length) {
          this._handleCreateOptsSetting(this.settingArray.excel);
          return;
        }
        break;

      case BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_GOOGLE_SHEET:
        if (this.settingArray.google.length) {
          this._handleCreateOptsSetting(this.settingArray.google);
          return;
        }
        break;
    }

    this.googleSheetService.loadSettingColumns(params).subscribe({
      next: res => {
        const settings = !res.code ? [] : res.data;
        this._handleCreateOptsSetting(settings);

        switch (params.format) {
          case BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_EXCEL:
            this.settingArray.excel = settings;
            break;

          case BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_GOOGLE_SHEET:
            this.settingArray.google = settings;
            break;
        }
      }
    })
  }

  private _handleCreateOptsSetting(settings: IBusinessExportDataSetting[]) {
    this.settingOptions = settings.map(st => this._genOtpSetting(st))
  }

  private _genOtpSetting(st: IBusinessExportDataSetting): ISelectOption {
    let classFont = 'fal fa-shop';
    let title = 'Doanh nghiệp';
    if (st.scopeType == this.GOOGLE_SHEET_CONSTS.TYPE_SCOPE_USER) {
      classFont = 'fal fa-user'
      title = 'Cá nhân'
    }
    return {
      value: st.id,
      label: st.name,
      iconLeft: {
        classFont: classFont,
        title: title
      }
    }
  }


  /**
   * ------------------------------------------------------------------------------------------------------------------
   * Handle on change -------------------------------------------------------------------------------------------------
   * ------------------------------------------------------------------------------------------------------------------
   * */
  onChangeFileSheetName(value: string) {
    const key = 'fileNew.sheetName';
    const maxLength = 31;
    if (value.length <= maxLength) {
      delete this.errors[key];
    } else {
      this.errors[key] = 'common.sheetName.limit';
    }
  }

  // Chọn file có sẵn | file tạo mới
  onChangeTypeUseFile($event: number) {
    this.state.typeUseFile = $event;

    // Nếu tạo file mới thì sheet name cũng đổi sang loại tạo mới
    if ($event == TYPE_USE.NEW) {
      this.state.googleFile.typeUseSheet = TYPE_USE.NEW;
    }
  }

  // Chọn Sheet có sẵn
  onChangeGoogleSheetId(sheetId: number) {
    const find = this.sheetOptions.find(o => o.value == sheetId);
    this.state.googleFile.spreadSheetId = sheetId;
    this.state.googleFile.spreadSheetTitle = find ? find.label : '';

    this.onChangeValue('spreadSheetId', sheetId)
  }


  /**
   * Handle display columns -------------------------------------------------------------------------------------------
   * */
  colChange(value: any, col: IDisplayColumn) {
    if (col.required) {
      return;
    }
    col.display = value == 1;
    this.handleCheckAll();
  }

  /**
   * Thay đổi sắp xếp hiển thị
   * */
  dropDragField(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.state.columns, event.previousIndex, event.currentIndex);
  }

  /**
   * - Hiện tất cả cột
   * - Ẩn tất cả cột
   *
   * @Note: Đối với cột required thì không thay đổi
   * */
  onCheckAll() {
    const checked = !this.isCheckAll;
    this.isCheckAll = checked;
    this.state.columns.forEach((f: any) => {
      f.display = f.required ? true : checked;

      if (f.childs) {
        f.childs.forEach((fc: any) => {
          fc.display = fc.required ? true : checked;
        })
      }
    })
  }

  /**
   * Kiểm tra xem có đang check all hiển thị thay đổi icon
   * */
  private handleCheckAll() {
    this.isCheckAll = this.state.columns.every((f: any) => {
      if (f.childs) {
        // Kiểm tra tất cả phần tử con
        return f.childs.every((fc: any) => fc.display || fc.required);
      } else {
        // Kiểm tra phần tử cha
        return f.display || f.required;
      }
    });
  }

  /**
   * Handle setting ---------------------------------------------------------------------------------------------------
   * */

  onHandleSetting(useSetting: any) {
    this.settingState.useSetting = useSetting;
    if (!useSetting) return;

    this._handleSettingSaveds();
  }

  private _handleSettingSaveds() {
    const typeScope = this.settingState.typeScope;
    const tabRef = this.state.tabRef;
    let settings = this.settingArray.excel;
    if (tabRef == 'googleSheets') {
      settings = this.settingArray.google;
    }

    this.settingState.settingSaveds = [
      ...settings.filter(st => st.scopeType === typeScope)
        .map(st => this._genOtpSetting(st))
    ]
  }

  // Chọn cài đặt
  onChangeSettingId(settingId: number) {
    this.state.settingId = settingId;

    const sttArray =
      this.state.tabRef == 'excel' ?
        this.settingArray.excel : this.settingArray.google;

    const setting = sttArray.find(st => st.id == settingId);
    if (setting) {
      const { configs, columns } = { ...setting };
      this.state.pageSelection = configs && configs.pageSelection ? configs.pageSelection : 'recordAll';
      this.state.typeUseFile = configs && configs.typeUseFile ? configs.typeUseFile : TYPE_USE.NEW;
      this.state.fileNew = configs.fileNew;
      this.state.googleFile = configs.googleFile;
      this.state.columns = [...columns];
    }
  }

  onChangeScopeSetting(scope: number) {
    this.settingState.typeScope = castInt(scope);
    this._handleSettingSaveds();
  }

  onChangeTypeSetting(type: number) {
    this.settingState.settingTypeSave = castInt(type)
  }

  // Xóa cài đặt đã lưu
  onRemoveSetting(opt: ISelectOption) {
    this.appForm.notifyService.dialogConfirmDelete({
      content: 'common.excel.confirmDeleteSetting', // Bạn có chắc chắn muốn xóa cài đặt
      btnConfirmName: 'common.delete',
      windowClass: 'windowClassConfirmDelete',
    }).subscribe({
      next: (value: any) => {
        if (value && value.confirmDelete) {
          this.appForm.showLoading();
          this.googleSheetService.deleteSettingColumn({
            id: opt.value,
            businessId: this.authService.businessCurrent?.id ?? 0,
          }).subscribe({
            next: (res: any) => {
              if (!res.code) {
                this.appForm.notifyWarning(res.messages);
              } else {
                this.appForm.notifySuccess(res.messages);

                this.settingOptions = this.settingOptions.filter(
                  o => o.value != opt.value
                )
                switch (this.state.tabRef) {
                  case "excel":
                    this.settingArray.excel = this.settingArray.excel.filter(
                      o => o.id != opt.value
                    )
                    break;

                  case "googleSheets":
                    this.settingArray.google = this.settingArray.google.filter(
                      o => o.id != opt.value
                    )
                    break;
                }

                this._handleSettingSaveds();
              }
            },
            complete: () => this.appForm.hideLoading()
          })
        }
      }
    })
  }

  // Lưu cài đặt
  onSaveSetting(): any {
    if (!this.options.typeSettingExportData) return;
    const stat$ = this.state;
    const setting$ = { ...this.settingState };

    let format = BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_EXCEL;
    if (stat$.tabRef == 'googleSheets') {
      format = BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_GOOGLE_SHEET;
    }

    delete this.errors['settingName'];
    const params: IParamsSaveSettingExportDataColumns = {
      id: setting$.settingId,
      type: this.options.typeSettingExportData, // Màn hình
      scopeType: setting$.typeScope, // DN | CN
      format: format, // Excel | Google Sheet
      name: setting$.settingNewName ? setting$.settingNewName : '',
      columns: stat$.columns ? stat$.columns : [],
      configs: {
        typeUseFile: stat$.typeUseFile,
        pageSelection: stat$.pageSelection,
        fileNew: stat$.fileNew,
        googleFile: stat$.googleFile
      },
    }
    if (setting$.settingTypeSave == TYPE_USE.NEW) {
      params.id = undefined;
    } else if (setting$.settingTypeSave == TYPE_USE.AVAILABLE) {
      params.name = '';
    }

    this.settingState.isSubmit = true;
    this.appForm.showLoading();
    this.googleSheetService.saveSettingColumn(params).subscribe({
      next: (res: any) => {
        if (!res.code) {
          if (setting$.settingTypeSave == TYPE_USE.NEW) {
            if (res.errorCode == ERROR_CODE.ERR_INVALID_FORM_FIELDS && res.messages['name']) {
              this.errors['settingName'] = res.messages['name'];
              return;
            }
          }
          return this.appForm.notifyError(res.messages as any);
        }

        this.appForm.notifySuccess(res.messages as any);
        this.settingState = this._createStateSetting();
        if (params.id) {
          // Ghi đè thì không push mới
          return;
        }

        const setting = res.data;
        let classFont = 'fal fa-shop';
        let title = 'Doanh nghiệp';
        if (setting$.typeScope == this.GOOGLE_SHEET_CONSTS.TYPE_SCOPE_USER) {
          classFont = 'fal fa-user'
          title = 'Cá nhân'
        }
        this.settingOptions.unshift({
          value: setting.id,
          label: setting.name,
          iconLeft: {
            classFont: classFont,
            title: title
          }
        })

        switch (format) {
          case BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_EXCEL:
            this.settingArray.excel.push(setting);
            break;

          case BUSINESS_EXPORT_DATA_SETTING_CONSTS.FORMAT_GOOGLE_SHEET:
            this.settingArray.google.push(setting);
            break;
        }
        return;
      },
      complete: () => {
        this.settingState.isSubmit = false;
        this.appForm.hideLoading();
      }
    })
    return true;
  }

  /**
   * -----------------------------------------------------------------------------------------------------------------
   * Changes ----------------------------------------------------------------------------------------------------------
   * -----------------------------------------------------------------------------------------------------------------
   * */
  // Chọn tài khoản kết nối
  onSelectedToken(tokenId: number) {
    this.state.accessTokenId = tokenId;
  }

  // Thay đổi link file GGS
  override onChangeSpreadGGUrl(spreadUrl: string) {
    super.onChangeSpreadGGUrl(
      spreadUrl,
      this.state.accessTokenId
    )
  }


  /**
   * -----------------------------------------------------------------------------------------------------------------
   * Search ----------------------------------------------------------------------------------------------------------
   * -----------------------------------------------------------------------------------------------------------------
   * */
  private buildSearch() {
    this.controlKeypress.valueChanges.pipe(
      startWith(''),
      distinctUntilChanged(),
      debounceTime(50),
      tap(value => {
        if (typeof value === "string" && value.trim() == '') this.resetSearch();
      }),
      filter(value => value != null && value.trim() != ''),
    ).subscribe({
      next: key => {
        this.keypressSearch(key)
      }
    });

  }

  /**
   * Hàm chỉ xử lý update lại "filterHide" để đánh dấu cột phù hợp tiêu chí tìm kiếm
   * */
  private keypressSearch(key: string) {
    this.isResultSearch = false;
    let query = Diacritics.remove(key.toLowerCase())
    query = query.trimEnd()
    query = query.trimStart()

    this.state.columns = this.state.columns.map((f: any) => ({
      ...this._compareSearch(query, f),
      childs: f.childs ? [...f.childs.map((fc: any) => ({ ...this._compareSearch(query, fc) }))] : undefined,
    }))
  }

  private _compareSearch(q: string, f: IDisplayColumn): IDisplayColumn {
    const name = this._getNameCol(f);
    const normal = Diacritics.remove(name.toLowerCase())
    const has = !normal.includes(q);
    if (!has) {
      this.isResultSearch = true;
    }
    f['filterHide'] = has;
    return { ...f };
  }

  private _getNameCol(f: IDisplayColumn) {
    if (f.nameOriginal) {
      return f.nameOriginal;
    }

    if (f.name && f.name != '#') {
      return this.appForm.appService.translate(f.name)
    }

    return '';
  }

  /**
   * Reset search: xóa hết filterHide trong settingColumns
   * */
  resetSearch() {
    this.controlKeypress.setValue('', { emitEvent: false });
    this.isResultSearch = false;
    this.state.columns.forEach((f: any) => {
      f['filterHide'] = false

      if (f.childs) {
        f.childs.forEach((fc: any) => {
          fc['filterHide'] = false
        })
      }
    })
  }


  readonly GOOGLE_SHEET_CONSTS = GOOGLE_SHEET_ACCESS_TOKEN_CONSTS;
  readonly TYPE_USE = TYPE_USE;
  readonly SCREEN_GRID_MEDIUM = SCREEN_GRID_MEDIUM;
}


@Pipe({
  name: 'columnIndexExcel',
  standalone: true,
})
@Injectable({
  providedIn: 'root'
})
export class ColumnIndexExcelPipe implements PipeTransform {
  transform(index: number): string {
    let columnName = '';
    let dividend = index + 1;
    let modulo: number;

    while (dividend > 0) {
      modulo = (dividend - 1) % 26;
      columnName = String.fromCharCode(65 + modulo) + columnName;
      dividend = Math.floor((dividend - modulo) / 26);
    }

    return columnName;
  }
}
